import ListaModelo from "./ListaModelo"
import AlertDialogOnClose from "../../../../components/admin/AlertDiologOnClose";
export default function ModeloForm() {

    return(
        <AlertDialogOnClose nome={"Modelo"} placeholder={"Insira o nome do modelo"}>
            <ListaModelo />
        </AlertDialogOnClose>
    )
} 